import * as React from "react";

import { Input as UiInput } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/**
 * VisitorInput — Textfeld der Besucherliste, mit Fehlerzustand.
 *
 * Hülle um `@/components/ui/input`; `error` färbt den Rahmen rot.
 */
const VisitorInput = ({ className, error, ...props }) => (
  <UiInput
    className={cn(error && "border-danger focus:border-danger", className)}
    {...props}
  />
);

export default VisitorInput;
